/**
 * ProtectedRoute — 登录守卫 (布局路由)
 * 未登录跳转 /login 并记录来源路径
 * 渲染 <Outlet /> 以透传子路由
 */
import { Outlet, Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/store/auth'
import { ROUTES } from '@/routes'

export default function ProtectedRoute() {
  const location = useLocation()
  const accessToken = useAuthStore((s) => s.accessToken)
  const user = useAuthStore((s) => s.user)

  if (!accessToken || !user) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />
  }

  return <Outlet />
}
